module.exports = __webpack_public_path__ + "img/20190625161715668.0099e0b3.png";